import * as React from "react";

import { formatDate } from "../../../../../utils/misc";

import { TableBody, TableRow, TableCell, IconButton } from "@mui/material";
import Circle from "@mui/icons-material/Circle";
import PolicyIcon from "@mui/icons-material/Policy";

import WorkflowDropdown from "./WorkflowDropdown";
import DebugDeviceInfoButton from "./DebugDeviceInfoButton";

import { WORKFLOW_MODES } from "../../../../../constants";

export default function KiosksListTableBody({
  subscriptions,
  filterKioskID,
  filterTabIndex, //0 is active, 1 is inactive, 2 is all
  handleSetWorkflowModeKiosk
}) {
  const filterActiveFunc = activeFlag => {
    console.log("filterTabIndex", filterTabIndex);
    switch (filterTabIndex) {
      case 0: //All
        return true;
        break;
      case 1: //Active
        return activeFlag == true;
        break;

      case 2: //Inactive
        return activeFlag == false;
        break;
      default:
        return true;
        break;
    }
  };

  //if (subscriptions && subscriptions.kioskKeys) {
  //  console.log("[DEBUG] subscriptions.kioskKeys", subscriptions.kioskKeys);
  //}

  if (subscriptions && subscriptions.kioskKeys) {
    return (
      <React.Fragment>
        <TableBody>
          {subscriptions
            ? subscriptions.kioskKeys
                .filter(
                  kiosks =>
                    (filterKioskID === "" ||
                      kiosks.kioskID.includes(filterKioskID) ||
                      (kiosks.deviceID &&
                        kiosks.deviceID.includes(filterKioskID)) ||
                      (kiosks.serialID &&
                        kiosks.serialID.includes(filterKioskID))) &&
                    filterActiveFunc(kiosks.active)
                )
                .map(
                  row =>
                    row.kioskID && (
                      <TableRow
                        key={
                          row.kioskID +
                          formatDate(row.createdAt, "YYMMMDDHHmmss")
                        }
                      >
                        <TableCell component="th" scope="row">
                          {row.kioskID}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.deviceID}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.serialID}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.version}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.ip}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <WorkflowDropdown
                            initialValue={
                              row.kioskSettings
                                ? row.kioskSettings.workflowMode
                                : WORKFLOW_MODES.BAGS_AND_LABELS
                            }
                            handleSetWorkflowModeKiosk={
                              handleSetWorkflowModeKiosk
                            }
                            sessionID={subscriptions._id}
                            kioskID={row.kioskID}
                            kioskKeysID={row._id}
                          />
                        </TableCell>
                        {/* <TableCell component="th" scope="row">
                            {row.bagtags.length}
                          </TableCell> */}
                        {/* checks device internal data */}
                        {/* <TableCell component="th" scope="row">
                          <DebugDeviceInfoButton kioskID={row.kioskID} />
                        </TableCell> */}
                        <TableCell component="th" scope="row">
                          {/* {row.log.length} */}
                          <IconButton
                            size="small"
                            href={`/dashboard/ActivityLogs?kioskID=${row.kioskID}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <PolicyIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {formatDate(row.lastAccessed, "YYYY-MMM-DD HH:mm:ss")}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {formatDate(row.createdAt, "YYYY-MMM-DD HH:mm:ss")}
                        </TableCell>
                        <TableCell align="center" component="th" scope="row">
                          {row.active ? (
                            <Circle style={{ color: "lightgreen" }} />
                          ) : (
                            <Circle style={{ color: "red" }} />
                          )}
                        </TableCell>
                      </TableRow>
                    )
                )
            : ""}
        </TableBody>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <TableBody>Unable to load kiosk data. Please refresh</TableBody>
    </React.Fragment>
  );
}
